// File#: _2_table-of-contents
// Usage: codyhouse.co/license
(function () {
  var subnav = function (element) {
    this.element = element;
    this.list = this.element.getElementsByClassName("js-subnav__list")[0];
    this.content = document.getElementsByClassName("js-subnav-conten")[0];
    this.anchors = this.list.querySelectorAll('a[href^="#"]');
    this.sections = getSections(this);
    this.clickScrolling = false;
    this.intervalID = false;
    initsubnav(this);
  };

  function getSections(subnav) {
    var sections = [];
    // get all content sections
    for (var i = 0; i < subnav.anchors.length; i++) {
      var section = document.getElementById(
        subnav.anchors[i].getAttribute("href").replace("#", "")
      );
      if (section) sections.push(section);
    }
    return sections;
  }

  function initsubnav(subnav) {
    // listen for click on anchors
    subnav.list.addEventListener("click", function (event) {
      var anchor = event.target.closest('a[href^="#"]');
      if (!anchor) return;
      // reset link apperance
      subnav.clickScrolling = true;
      resetAnchors(subnav, anchor);
    });

    // check when a new section enters the viewport
    var observer = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (!subnav.clickScrolling) {
            // do not update classes if user clicked on a link
            getVisibleSection(subnav);
          }
        });
      },
      {
        threshold: [0, 0.1],
        rootMargin: "0px 0px -70% 0px",
      }
    );

    for (var i = 0; i < subnav.sections.length; i++) {
      observer.observe(subnav.sections[i]);
    }

    // detect the end of scrolling -> reactivate IntersectionObserver on scroll
    subnav.element.addEventListener("subnav-scroll", function (event) {
      subnav.clickScrolling = false;
    });
  }

  function resetAnchors(subnav, anchor) {
    if (!anchor) return;
    for (var i = 0; i < subnav.anchors.length; i++)
      Util.removeClass(subnav.anchors[i], "subnav__link--selected");
    Util.addClass(anchor, "subnav__link--selected");
  }

  function getVisibleSection(subnav) {
    if (subnav.intervalID) {
      clearInterval(subnav.intervalID);
    }
    subnav.intervalID = setTimeout(function () {
      var halfWindowHeight = window.innerHeight / 2,
        index = -1;
      for (var i = 0; i < subnav.sections.length; i++) {
        var top = subnav.sections[i].getBoundingClientRect().top;
        if (top < halfWindowHeight) index = i;
      }
      if (index > -1) {
        resetAnchors(subnav, subnav.anchors[index]);
      }
      subnav.intervalID = false;
    }, 100);
  }

  var subnavs = document.getElementsByClassName("js-subnav"),
    intersectionObserverSupported =
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype;

  var subnavsArray = [];
  if (subnavs.length > 0 && intersectionObserverSupported) {
    for (var i = 0; i < subnavs.length; i++) {
      (function (i) {
        subnavsArray.push(new subnav(subnavs[i]));
      })(i);
    }

    // listen to window scroll -> reset clickScrolling property
    var scrollId = false,
      customEvent = new CustomEvent("subnav-scroll");

    window.addEventListener("scroll", function () {
      clearTimeout(scrollId);
      scrollId = setTimeout(doneScrolling, 100);
    });

    function doneScrolling() {
      for (var i = 0; i < subnavsArray.length; i++) {
        (function (i) {
          subnavsArray[i].element.dispatchEvent(customEvent);
        })(i);
      }
    }
  }
})();
